var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33341 1.33325H11.5001C11.6823 1.33325 11.8334 1.48439 11.8334 1.66659C11.8334 1.84878 11.6823 1.99992 11.5001 1.99992H3.16675C2.43227 1.99992 1.83341 2.59878 1.83341 3.33325V13.3333C1.83341 13.5154 1.68227 13.6666 1.50008 13.6666C1.31789 13.6666 1.16675 13.5154 1.16675 13.3333V2.49992C1.16675 1.85939 1.69289 1.33325 2.33341 1.33325ZM5.66675 4.66658H14.8334C15.4739 4.66658 16.0001 5.19273 16.0001 5.83325V17.4999C16.0001 18.1404 15.4739 18.6666 14.8334 18.6666H5.66675C5.02622 18.6666 4.50008 18.1404 4.50008 17.4999V5.83325C4.50008 5.19273 5.02622 4.66658 5.66675 4.66658ZM6.50008 17.9999H14.0001C14.7346 17.9999 15.3334 17.4011 15.3334 16.6666V6.66658C15.3334 5.93211 14.7346 5.33325 14.0001 5.33325H6.50008C5.76561 5.33325 5.16675 5.93211 5.16675 6.66658V16.6666C5.16675 17.4011 5.76561 17.9999 6.50008 17.9999Z",
    fill: "#323232",
    stroke: "#344335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.a0db8df996b13d41e37bdb2e501e181a.svg";
export { ForwardRef as ReactComponent };